import { isObject } from "../../utils/is.js";
import { stringifyExternalJson } from "../../utils/json.js";
//#region src/api/exceptions/const.ts
const defaultExceptionType = "Error";
const defaultErrorArgsSerializer = (args) => {
	return args.map((arg) => {
		if (isObject(arg)) return stringifyExternalJson(arg);
		return String(arg);
	}).join(" ");
};
//#endregion
export { defaultErrorArgsSerializer, defaultExceptionType };

//# sourceMappingURL=const.js.map